/** Every tier key, in ascending order. Frozen to prevent mutation. */
export const ALL_TIER_KEYS = Object.freeze(['free', 'pro', 'enterprise']);
/** The tier a tenant lands on when none is specified at provision time. */
export const DEFAULT_TIER = 'free';
const TIER_KEY_VALUES = new Set(ALL_TIER_KEYS);
/** Runtime type guard: true when `v` is one of the known {@link TierKey} values. */
export function isTierKey(v) {
    return typeof v === 'string' && TIER_KEY_VALUES.has(v);
}
/**
 * The authoritative usage rule. `maxUsers === null` means UNLIMITED and is
 * special-cased FIRST — an unlimited tier is NEVER over limit regardless of
 * count. Otherwise a tenant is over limit strictly when `userCount > maxUsers`
 * (at-cap is NOT over).
 */
export function computeTenantUsage(userCount, maxUsers) {
    return {
        used: userCount,
        cap: maxUsers,
        overLimit: maxUsers !== null && userCount > maxUsers,
    };
}
/** Render usage as `used / cap`, with `∞` for an unlimited (null) cap. */
export function formatUsage(usage) {
    return usage.cap === null ? `${usage.used} / ∞` : `${usage.used} / ${usage.cap}`;
}
/** Count how many of the given usages are over their cap (soft-warn tally). */
export function countOverLimit(usages) {
    return usages.reduce((n, usage) => (usage.overLimit ? n + 1 : n), 0);
}
//# sourceMappingURL=compliance.js.map